import { createSelector } from 'reselect'
import { FOLDER_TYPE } from 'ducks/folders/constants'
import { selectCurrentFolders } from '.'

export const selectChatFolders = createSelector(selectCurrentFolders, folders =>
  folders.filter(folder =>
    [FOLDER_TYPE.CHAT, FOLDER_TYPE.ALL].includes(folder.type)
  )
)
